import { useEffect } from 'react';
import { Button, Theme, useMediaQuery } from '@mui/material';
import { useSetDefaultQueryMutation } from '@api/Trinium/Endpoints/BoardQueries/slice';
import { defaultAllOpenQuery } from '@api/Trinium/Endpoints/BoardQueries/types';
import { BoardQuery } from '@api/Trinium/types';
import { useAppDispatch } from '@reduxStore';
import { queueUncontrolledToast } from '@toast';

import styles from '@components/DataGrid/Dispatch/DataGrid.Dispatch.module.css';

/**
 * Button for setting the default Dispatch Board Query
 */
export default function SetDefaultQueryButton({
	terminalNumber,
	currentQuery,
	defaultQuery
}: {
	terminalNumber: string;
	currentQuery: BoardQuery;
	defaultQuery: BoardQuery | undefined;
}) {
	const appDispatch = useAppDispatch();
	const [setDefaultQuery, { isLoading, isError }] = useSetDefaultQueryMutation();
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	useEffect(() => {
		if (isError) {
			appDispatch(
				queueUncontrolledToast({
					type: 'message',
					message: 'Unable to set the default query, if the problem persists please contact IT Support.',
					severity: 'error',
					autoCloseMs: 5000
				})
			);
		}
	}, [isError, appDispatch]);

	if (isMobile || currentQuery.id === defaultQuery?.id || (currentQuery.id === defaultAllOpenQuery.id && !defaultQuery)) return <></>;

	return (
		<Button
			size='small'
			variant='text'
			color='info'
			onClick={() => {
				if (!isLoading) {
					// set default query by id or unset default query if the selected query is the defaultAllOpenQuery
					void setDefaultQuery({
						terminalNumber: terminalNumber,
						id: currentQuery.id === defaultAllOpenQuery.id && defaultQuery ? defaultQuery.id : currentQuery.id,
						isDefault: currentQuery.id !== defaultAllOpenQuery.id
					});
				}
			}}
			className={styles['set-default-query-btn']}
		>
			Set as Default Query
		</Button>
	);
}
